<template>
  <router-view />
</template>

<script>
export default {
  name: 'Document'
};
</script>
